import * as React from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { inject, observer } from "mobx-react";
import { StatusPageStore } from "../../lib/index";
//import testData from "./testdata.json";
import styles from "./StatusPageWidget.scss";
import logo from "../../static/brand/logo.png";
import icon from "../../static/brand/icon200.png";
import { faWifi } from "@fortawesome/fontawesome-pro-light";
import { faTimes } from "@fortawesome/fontawesome-pro-solid";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import { StatusPageMessageGenerator, StatusPageError } from "./StatusPage";

interface ITitle{
	date: Date;
}

interface IStatusProps{
	statusPageStore: StatusPageStore;
}

@inject ("statusPageStore")
@observer
export class StatusPageWidget extends React.Component<IStatusProps, any> {

	constructor(props) {
		super(props);
		this.state = {};
	}


	public render() {
		// in case there was no data -> setState takes some time (is async)
		let status = this.props.statusPageStore.status;
		let date = this.props.statusPageStore.date;
		if (!status) {
			let popover =
				<Popover className = {styles.statusWidget}  id = "popover" title = {<StatusWidgetTitle date = {date}/>}>
					<StatusPageError/>
				</Popover>;
			return (
				<OverlayTrigger trigger="click" rootClose placement="top" overlay={popover}>
					<span className = {styles.indicator}>
						<div>
							<FpLogo/>
							<span className = {`${styles.statusBadges} ${styles.err}`}>
								<span className="fa-stack fa-lg">
									<FontAwesomeIcon icon = {faWifi} className = "fa-stack-2x" style = {{fontSize: "8px", color: "black"}}/>
									<FontAwesomeIcon icon = {faTimes} className = "fa fa-stack-2x" style={{paddingLeft: "10px", paddingTop: "15px", fontSize: "12px", color: "red"}}/>
								</span>
							</span>
						</div>
					</span>
				</OverlayTrigger>
			);
		}
		let ins;
		let main;
		let popoverClickHasInfAboutIncidents;
		/*loops*/
		// loop over incidents
		try {
			ins = StatusPageMessageGenerator.getIncidents(status, 11, true);
			main = StatusPageMessageGenerator.getMaintence(status, 11, true);
			// loop over maintenances

			/*popovers*/
			// -> This will be used in case there are incidents or maintenances
			popoverClickHasInfAboutIncidents = (
				<Popover className = {styles.statusWidget}   id = "popover" title = {<StatusWidgetTitle date = {date}/>}>
					{ins}
						{((status.scheduled_maintenances.length > 0) && (status.incidents.length > 0)) && <hr className = {styles.hrStatus}/>}
					{main}
				</Popover>
			);
		} catch (err) {

			if (err === "TypeError") {
				popoverClickHasInfAboutIncidents = (
					<Popover className = {styles.statusWidget}   id = "popover" title = {<StatusWidgetTitle date = {date}/>}>
						<StatusPageError fontSize = {10}/>
					</Popover>
				);
			}

		}


		let warnings = 0;

		//now calculate some numbers and set a bool

		// show badge?
		warnings += status.incidents.length;
		warnings += status.scheduled_maintenances.length;

		//add auto generated incident when there is no information about the current incident
		if ((status.incidents.length === 0) && (status.status.indicator !== "none")) {
			warnings += 1;
		}

		/*return statement -> This will be rendered*/
		return (
			//this is the trigger for opening the window

			warnings > 0 ? <OverlayTrigger trigger="click" rootClose placement="top" overlay={popoverClickHasInfAboutIncidents}>
				<span className = {styles.indicator}>
					{warnings > 0 ?
						// <span className = {styles.status}>
						// 	<span className = {`${styles.statusBadges} ${styles[data.status.indicator]}`}>{warnings}</span>
						// 	{" "}{data.status.description}
						// </span>
						<div>
						<FpLogo/>
					<span className = {`${styles.statusBadges} ${styles[status.status.indicator]}`}>{warnings}</span></div>

					:
					<div>
					<FpLogo/>
					<span className = {`${styles.colorDot} ${styles[status.status.indicator]}`}></span>
					</div>
					}
				</span>
			</OverlayTrigger>
			: //when we have no warnings: do not use OverlayTrigger
			<a href="http://status.fleetplan.net/" target="_blank">
				<span className = {styles.indicator}>
					<div>
						<FpLogo/>
						<span className = {`${styles.colorDot} ${styles[status.status.indicator]}`}></span>
					</div>
				</span>
			</a>
		);
	}
}

/**
 * This is the component that represents the title
 */
class StatusWidgetTitle extends React.Component <ITitle, any>{
	constructor(props) {
		super(props);
		this.state = {
			date : this.props.date,
		};
	}

	public render() {
		let date = this.state.date;
		return(
			<div>
				<a style = {{fontSize: 10}} target = "_blank" href = "http://status.fleetplan.net/">
				<img
					src={icon}
					style={{ height: "12px", width: "12px", paddingBottom : "2px" }}
				/>
					{" "}statuspage.io
				</a>
				<p className = {styles.statusDate}> Last update:{" "}
					{date.getHours()}:{date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()}
				</p>
			</div>
		);
	}
}

class FpLogo extends React.Component <{}, {}>{
	public render() {
		return(
			<img
				src={logo}
				style = {{height: "28px", padding: "6px 17px 3px", marginTop: "1px"}}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/common/StatusPageWidget/StatusPageWidget.tsx